import { Link } from '@sravni/react-design-system/lib/Typography';
import React from 'react';

import { updateEvent } from 'shared/ui/PropagationInterceptor';

export const appendInlinePhoneToTitle = (title: string, phones?: string[]) => {
  const phone = phones?.[0];

  if (!phone) {
    return title;
  }

  return (
    <p>
      {title}{' '}
      <Link
        href={`tel:${phone}`}
        onClick={(e: React.MouseEvent) => updateEvent(e)}
      >
        {phone}
      </Link>
    </p>
  );
};
